import AccountInfoValidations from './AccountInfoValidations';
import BankingInfoValidations from './BankingInfoValidations';
import IncomeInfoValidations from './IncomeInfoValidations';
import MaritalInfoValidations from './MaritalInfoValidations';
import PersonalInfoValidations from './PersonalInfoValidations';

const validations = {
  ...AccountInfoValidations,
  ...BankingInfoValidations,
  ...IncomeInfoValidations,
  ...MaritalInfoValidations,
  ...PersonalInfoValidations,
  elecCommDisclosure: (state) => {
    if (!state.elecCommDisclosure) {
      return { elecCommDisclosure: true };
    }

    return {};
  }
};

export default validations;
